const REACT_APP_GA_TRACKING_CODE = 'G-FYZ4R196QN'
export default REACT_APP_GA_TRACKING_CODE
